export default __webpack_public_path__ + "static/ocorpoaberto-70a7448ae710cd66517eb9afcb239850.jpg";